var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfMenuPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12.4465,
    height: 12.4444,
    viewBox: "0 0 12.4465 12.4444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2085662261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.35553 12.4444H0.622197C0.27876 12.4444 0 12.1663 0 11.8222V0.622197C0 0.278103 0.27876 0 0.622197 0H4.35553C4.69897 0 4.97773 0.278103 4.97773 0.622197V11.8222C4.97773 12.1663 4.69897 12.4444 4.35553 12.4444Z",
    fill: "url(#paint0_linear_0_6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.8243 12.4444H8.09095C7.74751 12.4444 7.46875 12.1663 7.46875 11.8222V0.622197C7.46875 0.278103 7.74751 0 8.09095 0H11.8243C12.1677 0 12.4465 0.278103 12.4465 0.622197V11.8222C12.4465 12.1663 12.1677 12.4444 11.8243 12.4444Z",
    fill: "url(#paint1_linear_0_6)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_6",
    x1: 0,
    y1: 6.2222,
    x2: 4.97773,
    y2: 6.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ABA47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_6",
    x1: 7.46875,
    y1: 6.2222,
    x2: 12.4465,
    y2: 6.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ABA47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfMenuPause);
export default __webpack_public_path__ + "static/media/cf-menu-pause.3a045d0e798432083f0b0a6e2efab9b5.svg";
export { ForwardRef as ReactComponent };